import { PureComponent } from 'react';
import { clearLogs, fetchLogs } from '../actions';

import { LoaderAndText } from 'containers/LoaderAndText/LoaderAndText';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { makeSelectLogsLoading } from '../selectors';
import NetWorker from './Terminal/NetWorker';
import Tasker from './Terminal/Tasker';
import Worker from './Terminal/Worker';

class Logs extends PureComponent {
  static propTypes = {
    logsLoading: PropTypes.bool.isRequired,
    msg: PropTypes.object.isRequired,
    newSnapshot: PropTypes.bool.isRequired,
    onClearLogs: PropTypes.func.isRequired,
    onFetchLogs: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { newSnapshot, onFetchLogs } = this.props;
    if (!newSnapshot) {
      onFetchLogs();
    }
  }

  componentWillUnmount() {
    this.props.onClearLogs();
  }

  render() {
    const { msg, logsLoading } = this.props;
    if (logsLoading) {
      return (
        <div className='snapshots-content__tabs-box-body'>
          <LoaderAndText
            text={get(msg, 'refreshLoader.text')}
            bottomText={get(msg, 'refreshLoader.bottomText')}
          />
        </div>
      );
    }
    return (
      <div className='row'>
        <Tasker msg={get(msg, 'discovery.terminal')} />
        <Worker msg={get(msg, 'discovery.terminal')} />
        <NetWorker msg={get(msg, 'discovery.terminal')} />
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  logsLoading: makeSelectLogsLoading(),
});

function mapDispatchToProps(dispatch) {
  return {
    onClearLogs: () => dispatch(clearLogs()),
    onFetchLogs: () => dispatch(fetchLogs()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Logs);
